//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: ['markets', 'showTitle', 'initiallyVisible', 'forceVisible'],
  computed: {
    visible() {
        return this.outcomesVisible
    },
    grid() {
      if (_.get(this.market, 'outcomes.length') > 2) {
        return 'grid-cols-3'
      }
      return 'grid-cols-2'
    }
  },
  data() {
    return {
      outcomesVisible: false,
      loading: true,
      balance: null
    }
  },
    watch: {
    initiallyVisible: function (newOutcome, oldOutcome) {
    if (this.initiallyVisible) {
      this.outcomesVisible = true
    } else {
      this.outcomesVisible = false
    }
    }
  },
  mounted() {
    if (this.initiallyVisible) {
      this.outcomesVisible = true
    } else {
      this.outcomesVisible = false
    }
  },
  methods: {
    displayBetBuilder() {
      // this.$emit('display-builder')
    },
    toggle() {
      this.outcomesVisible = !this.outcomesVisible
    },
    show() {
      this.outcomesVisible = true
    },
    hide() {
      this.outcomesVisible = false
    }
  }
}
